import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon64: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M12.315 20C13.382 20 14.266 19.207 14.344 18.19L14.35 18.044L14.353 12.623H17.295C18.942 12.623 20.202 11.223 19.973 9.67001L19.944 9.509L18.355 2.086C18.107 0.930999 17.087 0.0940125 15.881 0.0190125L15.708 0.0140076L12.78 0.0130005C11.144 0.0130005 9.57201 0.340003 8.11801 0.884003C7.71201 1.036 7.339 1.19701 7 1.35901V0.5C7 0.224 6.776 0 6.5 0H2.729C1.222 0 0 1.22099 0 2.72699V12.992C0 13.268 0.224 13.491 0.5 13.491H6.5C6.776 13.491 7 13.268 7 12.992V12.211L7.84799 12.861L8.155 13.103L8.43701 13.332L8.664 13.529C9.628 14.41 10.201 15.309 10.273 16.253L10.28 16.456V18.043C10.28 19.08 11.116 19.92 12.164 19.995L12.315 20ZM6 12.492H1V2.72699C1 1.77299 1.774 0.998993 2.729 0.998993H6V12.492ZM12.315 19.001C11.779 19.001 11.346 18.626 11.287 18.154L11.279 18.051L11.28 16.456C11.28 15.099 10.559 13.906 9.33899 12.791L9.03101 12.526L8.66199 12.228L7.63199 11.442C7.24499 11.075 7.02899 10.579 7.02899 10.063C7.02899 10.005 7.019 9.948 7 9.896L6.99899 2.48099L7.20401 2.37399C7.57301 2.18599 7.99699 1.99701 8.46899 1.82001C9.68299 1.36601 10.984 1.075 12.33 1.021L12.78 1.01199L15.707 1.013C16.473 1.014 17.131 1.48799 17.341 2.15799L17.377 2.29501L18.966 9.71799C19.166 10.654 18.445 11.543 17.434 11.618L17.295 11.623H13.853C13.608 11.623 13.403 11.8 13.361 12.033L13.353 12.123L13.35 18.043C13.35 18.566 12.892 19.001 12.315 19.001Z"
        fill="#404040"
      />
    </Icon>
  )
}
